export default __webpack_public_path__ + "static/media/second.eb2b37b5.jpg";